// Ảnh đại diện của đơn vị — quy tắc chung cho web (cắt / thu nhỏ trước khi gửi) và api (kiểm lại khi nhận).
// Trình duyệt cắt vuông giữa ảnh, thu về AVATAR_RULES.side px, đổi sang JPEG; máy chủ chỉ kiểm loại file + dung lượng.

export const AVATAR_RULES = {
  /** Cạnh ảnh sau khi cắt vuông (px) — đủ nét cho vòng 40px trên màn 3x */
  side: 256,
  /** Dung lượng tối đa máy chủ nhận */
  maxBytes: 100 * 1024,
  /** Ảnh gốc người dùng chọn — quá thì báo ngay, không đọc */
  maxSourceBytes: 15 * 1024 * 1024,
} as const

export type AvatarMime = 'image/jpeg' | 'image/png'

/** Loại ảnh theo byte đầu file (không tin đuôi / Content-Type). Không phải JPEG / PNG → null. */
export function avatarMime(buf: Uint8Array): AvatarMime | null {
  if (buf.length >= 3 && buf[0] === 0xff && buf[1] === 0xd8 && buf[2] === 0xff) return 'image/jpeg'
  const png = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]
  if (buf.length >= 8 && png.every((b, i) => buf[i] === b)) return 'image/png'
  return null
}

/** Kiểm ảnh đã thu nhỏ. Trả câu báo lỗi, hoặc null nếu đạt. */
export function checkAvatar(buf: Uint8Array): string | null {
  if (buf.length === 0) return 'Chưa có ảnh'
  if (buf.length > AVATAR_RULES.maxBytes) return `Ảnh nặng quá ${Math.round(AVATAR_RULES.maxBytes / 1024)} KB sau khi thu nhỏ`
  if (!avatarMime(buf)) return 'File không phải ảnh JPEG / PNG'
  return null
}

/** Đường dẫn ảnh qua api công khai. ?v= (16 ký tự đầu sha256) vừa để lưu đệm lâu, vừa là khoá: thiếu / sai thì 404. */
export function avatarPath(shopId: string, sha256: string): string {
  return `/api/public/avatar/${encodeURIComponent(shopId)}?v=${sha256.slice(0, 16)}`
}
